import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["stroke"]
const _hoisted_3 = {
  key: 0,
  d: "M4 10.5L12 4l8 6.5V20a1 1 0 0 1-1 1h-5v-6H10v6H5a1 1 0 0 1-1-1v-9.5z"
}
const _hoisted_4 = {
  key: 6,
  d: "M12 3l2.2 4.4 4.8.7-3.5 3.4.8 4.8L12 14.5 7.7 16.3l.8-4.8L5 8.1l4.8-.7L12 3z"
}
const _hoisted_5 = {
  key: 7,
  d: "M9 6l6 6-6 6"
}
const _hoisted_6 = {
  key: 8,
  d: "M15 6l-6 6 6 6"
}
const _hoisted_7 = {
  key: 9,
  d: "M3 20h18M5 20V8l7-4 7 4v12M9 12h6M9 16h6"
}
const _hoisted_8 = {
  key: 10,
  d: "M12 20s-7-4.2-7-9.2A3.8 3.8 0 0 1 12 8a3.8 3.8 0 0 1 7 2.8C19 15.8 12 20 12 20z"
}
const _hoisted_9 = {
  key: 13,
  d: "M12 5v14M5 12h14"
}
const _hoisted_10 = {
  key: 18,
  d: "M6 6l12 12M18 6L6 18"
}
const _hoisted_11 = {
  key: 19,
  d: "M5 12.5l4.5 4.5L19 7"
}
const _hoisted_12 = {
  key: 21,
  d: "M5 7h14M5 12h14M5 17h14"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppIcon',
  props: {
    name: {},
    size: { default: 22 },
    stroke: { default: 'currentColor' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    class: "app-ico",
    width: __props.size,
    height: __props.size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, [
    _createElementVNode("g", {
      stroke: __props.stroke,
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, [
      (__props.name === 'home')
        ? (_openBlock(), _createElementBlock("path", _hoisted_3))
        : (__props.name === 'search')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _cache[0] || (_cache[0] = _createElementVNode("circle", {
                cx: "11",
                cy: "11",
                r: "6.5"
              }, null, -1)),
              _cache[1] || (_cache[1] = _createElementVNode("path", { d: "M16.5 16.5L20 20" }, null, -1))
            ], 64))
          : (__props.name === 'building')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _cache[2] || (_cache[2] = _createElementVNode("path", { d: "M4 20V7l8-3 8 3v13" }, null, -1)),
                _cache[3] || (_cache[3] = _createElementVNode("path", { d: "M9 20v-5h6v5" }, null, -1)),
                _cache[4] || (_cache[4] = _createElementVNode("path", { d: "M8 10h.01M12 10h.01M16 10h.01M8 14h.01M12 14h.01M16 14h.01" }, null, -1))
              ], 64))
            : (__props.name === 'user')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _cache[5] || (_cache[5] = _createElementVNode("circle", {
                    cx: "12",
                    cy: "8",
                    r: "3.2"
                  }, null, -1)),
                  _cache[6] || (_cache[6] = _createElementVNode("path", { d: "M5 20c1.5-3.2 4-5 7-5s5.5 1.8 7 5" }, null, -1))
                ], 64))
              : (__props.name === 'inbox')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                    _cache[7] || (_cache[7] = _createElementVNode("path", { d: "M4 8l2-4h12l2 4v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8z" }, null, -1)),
                    _cache[8] || (_cache[8] = _createElementVNode("path", { d: "M4 8h16M9 13h6" }, null, -1))
                  ], 64))
                : (__props.name === 'users')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                      _cache[9] || (_cache[9] = _createElementVNode("path", { d: "M16 20v-1.5c0-2-1.8-3.5-4-3.5H7c-2.2 0-4 1.5-4 3.5V20" }, null, -1)),
                      _cache[10] || (_cache[10] = _createElementVNode("circle", {
                        cx: "9.5",
                        cy: "7",
                        r: "3"
                      }, null, -1)),
                      _cache[11] || (_cache[11] = _createElementVNode("path", { d: "M21 20v-1.2c0-1.7-1.2-3-2.8-3.3" }, null, -1)),
                      _cache[12] || (_cache[12] = _createElementVNode("path", { d: "M17.2 7.2a2.5 2.5 0 0 1 0 4.6" }, null, -1))
                    ], 64))
                  : (__props.name === 'badge')
                    ? (_openBlock(), _createElementBlock("path", _hoisted_4))
                    : (__props.name === 'chevron')
                      ? (_openBlock(), _createElementBlock("path", _hoisted_5))
                      : (__props.name === 'back')
                        ? (_openBlock(), _createElementBlock("path", _hoisted_6))
                        : (__props.name === 'center')
                          ? (_openBlock(), _createElementBlock("path", _hoisted_7))
                          : (__props.name === 'care')
                            ? (_openBlock(), _createElementBlock("path", _hoisted_8))
                            : (__props.name === 'refresh')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 11 }, [
                                  _cache[13] || (_cache[13] = _createElementVNode("path", { d: "M4.5 12a7.5 7.5 0 0 1 12.7-5.4" }, null, -1)),
                                  _cache[14] || (_cache[14] = _createElementVNode("path", { d: "M17.5 4.5v3.2h-3.2" }, null, -1)),
                                  _cache[15] || (_cache[15] = _createElementVNode("path", { d: "M19.5 12a7.5 7.5 0 0 1-12.7 5.4" }, null, -1)),
                                  _cache[16] || (_cache[16] = _createElementVNode("path", { d: "M6.5 19.5v-3.2h3.2" }, null, -1))
                                ], 64))
                              : (__props.name === 'calendar')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 12 }, [
                                    _cache[17] || (_cache[17] = _createElementVNode("rect", {
                                      x: "4",
                                      y: "5",
                                      width: "16",
                                      height: "15",
                                      rx: "2"
                                    }, null, -1)),
                                    _cache[18] || (_cache[18] = _createElementVNode("path", { d: "M8 3.5v3M16 3.5v3M4 10h16" }, null, -1)),
                                    _cache[19] || (_cache[19] = _createElementVNode("path", { d: "M9 14h.01M12 14h.01M15 14h.01M9 17h.01M12 17h.01" }, null, -1))
                                  ], 64))
                                : (__props.name === 'plus')
                                  ? (_openBlock(), _createElementBlock("path", _hoisted_9))
                                  : (__props.name === 'clock')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 14 }, [
                                        _cache[20] || (_cache[20] = _createElementVNode("circle", {
                                          cx: "12",
                                          cy: "12",
                                          r: "8"
                                        }, null, -1)),
                                        _cache[21] || (_cache[21] = _createElementVNode("path", { d: "M12 8v4.5l3 1.5" }, null, -1))
                                      ], 64))
                                    : (__props.name === 'edit')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 15 }, [
                                          _cache[22] || (_cache[22] = _createElementVNode("path", { d: "M4 20h4.5L19 9.5 14.5 5 4 15.5V20z" }, null, -1)),
                                          _cache[23] || (_cache[23] = _createElementVNode("path", { d: "M12.5 7l4.5 4.5" }, null, -1))
                                        ], 64))
                                      : (__props.name === 'trash')
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 16 }, [
                                            _cache[24] || (_cache[24] = _createElementVNode("path", { d: "M5 7h14M10 7V5h4v2M8 7v12a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V7" }, null, -1)),
                                            _cache[25] || (_cache[25] = _createElementVNode("path", { d: "M10 11v5M14 11v5" }, null, -1))
                                          ], 64))
                                        : (__props.name === 'note')
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 17 }, [
                                              _cache[26] || (_cache[26] = _createElementVNode("path", { d: "M7 3h7l5 5v11a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" }, null, -1)),
                                              _cache[27] || (_cache[27] = _createElementVNode("path", { d: "M14 3v5h5M8 13h8M8 17h5" }, null, -1))
                                            ], 64))
                                          : (__props.name === 'close')
                                            ? (_openBlock(), _createElementBlock("path", _hoisted_10))
                                            : (__props.name === 'check')
                                              ? (_openBlock(), _createElementBlock("path", _hoisted_11))
                                              : (__props.name === 'bell')
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 20 }, [
                                                    _cache[28] || (_cache[28] = _createElementVNode("path", { d: "M12 4a5 5 0 0 1 5 5v2.5c0 .8.3 1.6.8 2.2L19 15H5l1.2-1.3c.5-.6.8-1.4.8-2.2V9a5 5 0 0 1 5-5z" }, null, -1)),
                                                    _cache[29] || (_cache[29] = _createElementVNode("path", { d: "M10 18a2 2 0 0 0 4 0" }, null, -1))
                                                  ], 64))
                                                : (__props.name === 'menu')
                                                  ? (_openBlock(), _createElementBlock("path", _hoisted_12))
                                                  : (__props.name === 'chat')
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 22 }, [
                                                        _cache[30] || (_cache[30] = _createElementVNode("path", { d: "M5 6.5A2.5 2.5 0 0 1 7.5 4h9A2.5 2.5 0 0 1 19 6.5v7A2.5 2.5 0 0 1 16.5 16H11l-3.5 3v-3H7.5A2.5 2.5 0 0 1 5 13.5v-7z" }, null, -1)),
                                                        _cache[31] || (_cache[31] = _createElementVNode("path", { d: "M8.5 9h7M8.5 12h4.5" }, null, -1))
                                                      ], 64))
                                                    : (__props.name === 'rfid')
                                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 23 }, [
                                                          _cache[32] || (_cache[32] = _createElementVNode("rect", {
                                                            x: "5",
                                                            y: "7",
                                                            width: "14",
                                                            height: "10",
                                                            rx: "2"
                                                          }, null, -1)),
                                                          _cache[33] || (_cache[33] = _createElementVNode("path", { d: "M8 12h.01M11 10.5v3M14 9.5v5" }, null, -1))
                                                        ], 64))
                                                      : (__props.name === 'download')
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 24 }, [
                                                            _cache[34] || (_cache[34] = _createElementVNode("path", { d: "M12 4v10" }, null, -1)),
                                                            _cache[35] || (_cache[35] = _createElementVNode("path", { d: "M8 10l4 4 4-4" }, null, -1)),
                                                            _cache[36] || (_cache[36] = _createElementVNode("path", { d: "M5 19h14" }, null, -1))
                                                          ], 64))
                                                        : (__props.name === 'warn')
                                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 25 }, [
                                                              _cache[37] || (_cache[37] = _createElementVNode("path", { d: "M12 4l8.5 15H3.5L12 4z" }, null, -1)),
                                                              _cache[38] || (_cache[38] = _createElementVNode("path", { d: "M12 10v4" }, null, -1)),
                                                              _cache[39] || (_cache[39] = _createElementVNode("path", { d: "M12 16.6v.2" }, null, -1))
                                                            ], 64))
                                                          : (__props.name === 'help')
                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 26 }, [
                                                                _cache[40] || (_cache[40] = _createElementVNode("circle", {
                                                                  cx: "12",
                                                                  cy: "12",
                                                                  r: "8.2"
                                                                }, null, -1)),
                                                                _cache[41] || (_cache[41] = _createElementVNode("path", { d: "M9.6 9.3a2.5 2.5 0 1 1 3.3 2.4c-.7.4-1.1 1-1.1 1.8" }, null, -1)),
                                                                _cache[42] || (_cache[42] = _createElementVNode("path", { d: "M12 17.1h.01" }, null, -1))
                                                              ], 64))
                                                            : (__props.name === 'camera')
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 27 }, [
                                                                  _cache[43] || (_cache[43] = _createElementVNode("path", { d: "M4 8.5h3l1.4-2.2h7.2L17 8.5h3v10.2a1.3 1.3 0 0 1-1.3 1.3H5.3A1.3 1.3 0 0 1 4 18.7V8.5z" }, null, -1)),
                                                                  _cache[44] || (_cache[44] = _createElementVNode("circle", {
                                                                    cx: "12",
                                                                    cy: "13.6",
                                                                    r: "3.2"
                                                                  }, null, -1))
                                                                ], 64))
                                                              : (__props.name === 'receipt')
                                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 28 }, [
                                                                    _cache[45] || (_cache[45] = _createElementVNode("path", { d: "M7 3.5h10v17l-1.6-1-1.6 1-1.6-1-1.6 1-1.6-1-1.6 1V3.5z" }, null, -1)),
                                                                    _cache[46] || (_cache[46] = _createElementVNode("path", { d: "M9.2 8h5.6M9.2 11.2h5.6M9.2 14.4h3.6" }, null, -1))
                                                                  ], 64))
                                                                : (__props.name === 'ledger')
                                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 29 }, [
                                                                      _cache[47] || (_cache[47] = _createElementVNode("path", { d: "M5 4.5h12a2 2 0 0 1 2 2v13H7a2 2 0 0 1-2-2v-13z" }, null, -1)),
                                                                      _cache[48] || (_cache[48] = _createElementVNode("path", { d: "M7 4.5v13" }, null, -1)),
                                                                      _cache[49] || (_cache[49] = _createElementVNode("path", { d: "M10.5 9h5M10.5 12.5h5M10.5 16h3.2" }, null, -1))
                                                                    ], 64))
                                                                  : _createCommentVNode("", true)
    ], 8, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})